import styled from "styled-components";
import { TableContainer } from "../../styles";

/** Cores do exemplo: cabeçalho seção ${(props: any) => props.theme.colors.cf8f8f8}, cabeçalho tabela ${(props: any) => props.theme.colors.interfacePure100}, texto ${(props: any) => props.theme.colors.c808080}, bordas cinza claro */
export const COR_BORDA = "var(--hist-tbl-border)";
export const COR_FAIXA_FUNDO = "var(--hist-tbl-faixa-bg)";
export const COR_FAIXA_TEXTO = "var(--hist-tbl-faixa-text)";
export const COR_THEAD_FUNDO = "var(--hist-tbl-thead-bg)";
export const COR_TEXTO = "var(--hist-tbl-text)";
export const COR_VAZIO = "var(--hist-tbl-empty)";

export const StyledTableContainer = styled(TableContainer)`
  .data-table {
    font-size: 12px;

    thead {
      th {
        text-align: left;
        padding: 8px;
        font-weight: 500;
        font-size: 12px;
        color: ${({ theme }) => theme.colors.c000000};
        white-space: nowrap;
      }
    }

    tbody {
      tr {
        td {
          padding: 8px;
          font-size: 12px;

          &.field-cell {
            text-align: left;
            padding: 8px;
            font-weight: 500;
            font-size: 12px;
            color: rgb(100, 116, 139);
            white-space: nowrap;
          }

          &.before-cell {
            color: rgb(100, 116, 139) !important;
          }

          &.after-cell {
            color: ${({ theme }) => theme.colors.c000000};
          }
        }
      }
    }
  }
`;

/** Box com faixa superior no estilo do exemplo (Partes do Processo) */
export const BoxComFaixa = styled.div`
  border-radius: 8px;
  border: 1px solid ${COR_BORDA};
  overflow: hidden;
  margin-bottom: 20px;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FaixaTitulo = styled.div`
  background-color: ${COR_FAIXA_FUNDO};
  padding: 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: ${COR_FAIXA_TEXTO};
  border-bottom: 1px solid ${COR_BORDA};
`;

/** Tabela no estilo do exemplo: thead ${(props: any) => props.theme.colors.interfacePure100}, linhas com borda fina, texto cinza escuro */
export const TableContainerEstiloExemplo = styled(TableContainer)`
  border: none;
  border-radius: 0;

  .data-table {
    font-size: 12px;
    border: none;

    thead {
      background-color: ${COR_THEAD_FUNDO};

      th {
        text-align: left;
        padding: 8px;
        font-weight: 500;
        font-size: 12px;
        color: ${({ theme }) => theme.colors.c000000};
        white-space: nowrap;
      }
    }

    tbody tr {
      background-color: ${(props: any) => props.theme.colors.interfacePure0};

      &.border-top {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }

      td {
        padding: 8px;
        font-size: 12px;
        color: ${COR_TEXTO};

        &.field-cell {
          text-align: left;
          padding: 8px;
          font-weight: 500;
          font-size: 12px;
          color: rgb(100, 116, 139);
          white-space: nowrap;
        }

        &.before-cell {
          color: rgb(100, 116, 139) !important;
        }

        &.after-cell {
          color: ${({ theme }) => theme.colors.c000000};
        }

        &.empty-value {
          color: ${COR_VAZIO};
          font-style: normal;
        }
      }
    }
  }
`;

export const EmptyCell = styled.span`
  color: ${COR_VAZIO};
  font-weight: 500;
  display: inline-flex;
  align-items: center;

  .x-icon {
    width: 14px;
    height: 14px;
  }
`;
